import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export function Journal() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/journal").then(r => setItems(r.data)); }, []);
  return (
    <div className="bg-ivory text-ink pt-32 pb-24 min-h-screen">
      <div className="max-w-[1200px] mx-auto px-8 md:px-16">
        <div className="text-center mb-20">
          <p className="text-[10px] tracking-luxury uppercase text-goldDark mb-6">The House Journal</p>
          <h1 className="font-editorial text-5xl md:text-7xl leading-[0.95] tracking-tight">Journal</h1>
          <div className="rule-gold w-32 mx-auto my-10" />
          <p className="max-w-2xl mx-auto text-ink/70 leading-relaxed">Atelier notes, campaign essays and stories from the house.</p>
        </div>

        {items.length === 0 ? (
          <div className="text-center py-16 border border-black/10" style={{ background: "#f4ecd8" }}>
            <p className="font-editorial-italic text-2xl text-ink/50">The first essay is being written.</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-8">
            {items.map((p, i) => (
              <Link key={p.id} data-testid={`journal-${p.slug}`} to={`/journal/${p.slug}`} className="group animate-fade-up" style={{ animationDelay: `${i*60}ms` }}>
                {p.hero_image && <div className="aspect-[4/5] overflow-hidden hover-shift bg-parchment"><img src={p.hero_image} alt={p.title} className="w-full h-full object-cover" /></div>}
                <p className="text-[10px] tracking-widest-plus uppercase text-goldDark mt-4 mb-2">{p.category || "Essay"} · {new Date(p.created_at).toLocaleDateString()}</p>
                <h2 className="font-editorial text-3xl leading-tight">{p.title}</h2>
                {p.excerpt && <p className="mt-3 text-ink/70 leading-relaxed">{p.excerpt}</p>}
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export function JournalDetail() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/journal/${slug}`).then(r => setP(r.data)).catch(() => setP({error:true})); }, [slug]);
  if (!p) return <div className="pt-40 text-center text-ink/50">Loading…</div>;
  if (p.error) return <div className="pt-40 text-center">Not found</div>;
  return (
    <div className="bg-ivory text-ink">
      {p.hero_image && (
        <section className="relative h-[70vh] overflow-hidden">
          <img src={p.hero_image} alt="" className="absolute inset-0 w-full h-full object-cover animate-slow-zoom" />
          <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom, transparent 40%, rgba(43,31,20,0.4) 100%)" }} />
          <div className="relative h-full flex items-end px-8 md:px-16 pb-16 max-w-[1200px] mx-auto text-ivory">
            <div>
              <p className="text-[10px] tracking-widest-plus uppercase text-gold mb-2">{p.category || "Essay"}</p>
              <h1 className="font-editorial text-5xl md:text-8xl leading-[0.95] tracking-tight">{p.title}</h1>
            </div>
          </div>
        </section>
      )}
      <article
        className="max-w-3xl mx-auto px-8 py-24 text-lg leading-relaxed text-ink/85 font-light journal-body"
        dangerouslySetInnerHTML={{ __html: /<[a-z][\s\S]*>/i.test(p.body || "") ? p.body : `<p>${(p.body || "").replace(/\n/g, "<br/>")}</p>` }}
      />
      <div className="text-center pb-24"><Link to="/journal" className="tracking-widest-plus text-[11px] uppercase link-draw">← Return to the Journal</Link></div>
    </div>
  );
}
